import React, { useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import './UsersList.css';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import TopBar from "./TopBar";
import { Col, Container, Form, Row } from "react-bootstrap";
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import useAuth from "../../hooks/useAuth";

const ListSthanUsers = () => {
  const { auth } = useAuth();
  const [SthanUsers, setSthanUsers] = useState([])
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const SthanUsersPerPage = 15;
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const { SthanId, SthanName } = useParams();
  const [errMsg, setErrMsg] = useState("");
  const [sucssMsg, setSucssMsg] = useState("");

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [otpDetails, setOtpDetails] = useState(null);


  const fetchSthanUsers = useCallback(async () => {
    setError(null); // clear previous error
    try {
      const response = await axiosPrivate.get(`list-sthan-users?sthan_id=${SthanId}`, {
        withCredentials: true,
      });
      const SthanUserList = response.data;
      setSthanUsers(SthanUserList);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching Sthan User:", error);
      setError(error?.response?.data?.message?.toString() || error?.message || "No Sthan User available.");
      setLoading(false);
    }
  }, [SthanId]); // 👈 dependency added



  const showMessage = (type, message) => {
    if (type === 'error') {
      setErrMsg(message);
      setSucssMsg(""); // ensure success message is cleared
    } else if (type === 'success') {
      setSucssMsg(message);
      setErrMsg(""); // ensure error message is cleared
      setShowSuccessModal(true); // Show modal
    }

  };

  // const handleViewClick = async (personId) => {
  //   try {
  //     const response = await axiosPrivate.get(`get-sthan-user-otp?person_id=${personId}`, {
  //       withCredentials: true,
  //     });

  //     const { message, otp, expiry } = response.data;

  //     const formattedMessage = `
  //       ${message}
  //       OTP: ${otp}<br>
  //       Expiry: ${expiry}
  //     `;

  //     showMessage('success', formattedMessage);
  //   } catch (error) {
  //     console.error("Error fetching OTP:", error);
  //     setError(
  //       error?.response?.data?.message?.toString() ||
  //       error?.message ||
  //       "No OTP available."
  //     );
  //   }
  // };

  const handleViewClick = async (personId) => {
    try {
      const response = await axiosPrivate.get(`get-sthan-user-otp?person_id=${personId}`, {
        withCredentials: true,
      });

      setOtpDetails(response.data); // store the full object
      setShowSuccessModal(true);    // show modal
    } catch (error) {
      console.error("Error fetching OTP:", error);
      setError(
        error?.response?.data?.message?.toString() ||
        error?.message ||
        "No OTP available."
      );
    }
  };


  const handleArthiksakhaAddSthantoUser = (personId, name, mobile) => {
    const encodedName = encodeURIComponent(name);
    const encodedMobile = encodeURIComponent(mobile);

    navigate(`/arthiksakha/add/SthanToUser?person_id=${personId}&name=${encodedName}&mobile=${encodedMobile}`);
  };

  const handleAdminAddSthantoUser = (personId, name, mobile) => {
    const encodedName = encodeURIComponent(name);
    const encodedMobile = encodeURIComponent(mobile);

    navigate(`/admin/add/SthanToUser?person_id=${personId}&name=${encodedName}&mobile=${encodedMobile}`);
  };



  const handleEditClick = (personId, Name, Mobile, Responsibility) => {
    const responsibilityValue = Responsibility || 'Nill'; // fallback to empty string if undefined or null
    navigate(`/update/sthanUser/${personId}/${Name}/${Mobile}/${responsibilityValue}`);
  };


  const handleChangePswdClick = (Id, Name) => {
    navigate(`/change/SthanUserPswd/${Id}/${Name}`);
  };

  useEffect(() => {
    fetchSthanUsers();
  }, [SthanId]);


  const indexOfLastSthanUsers = currentPage * SthanUsersPerPage;
  const indexOfFirstSthanUsers = indexOfLastSthanUsers - SthanUsersPerPage;
  const currentSthanUsers = SthanUsers.slice(indexOfFirstSthanUsers, indexOfLastSthanUsers);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPages = Math.ceil(SthanUsers.length / SthanUsersPerPage);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  // if (error) {
  //   return <div className="error">{error}</div>;
  // }

  return (
    <>

      {/* <Container> */}
      <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} centered>
        <Modal.Header closeButton>
          {/* <Modal.Title>Success</Modal.Title> */}
        </Modal.Header>
        <Modal.Body>
          {otpDetails && (
            <div>
              <center>
                <h5 className="newotph">{otpDetails.message}</h5>
                <h6>OTP - <span className="otpnewspan"> {otpDetails.otp} </span></h6>
                <p className="otpnewp"><strong>Expiry - </strong> {otpDetails.expiry}</p>
              </center>
            </div>
          )}

        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="success" onClick={() => setShowSuccessModal(false)}>
            OK
          </Button>
        </Modal.Footer> */}
      </Modal>
      <section className="empbody">
        <div className="wrapperemp2">
          {/* <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">+ Create Vibhag</button> */}
          <h3>List sthan users in {SthanName}.</h3>


          <table id="customers">
            <thead>
              <tr>
                <th>Sthan name</th>
                <th>Person name</th>
                <th>Mobile</th>
                <th>Responsibility</th>
                <th>Mandalam name</th>
                <th>Khand name</th>
                <th>Is user signed up</th>
                <th>Options</th>
              </tr>
            </thead>

            <tbody>
              {error ? (
                <tr>
                  <td colSpan="6" className="text-danger text-center">
                    {error}
                  </td>
                </tr>
              ) : SthanUsers.length === 0 ? (
                <tr>
                  <td colSpan="6">No Data available.</td>
                </tr>
              ) : (
                currentSthanUsers.map(SthanUser => (
                  <tr key={SthanUser.person_id}>
                    <td>{SthanUser.sthan_name}</td>
                    <td>{SthanUser.name}</td>
                    <td>{SthanUser.mobile}</td>
                    <td>{SthanUser.responsibility}</td>
                    <td>{SthanUser.mandal_name}</td>
                    <td>{SthanUser.khand_name}</td>
                    <td>{SthanUser.is_user_signed_up ? 'Yes' : 'No'}</td>

                    <td>
                      <div className="d-flex justify-content-center">
                        {/* <button type="button" className="btn btn-warning btn-ico" >
                        <i className="bx bxs-edit icon"></i>
                      </button> */}
                        <button type="button" className="tableButton btn btn-info newicobtn newviewbtn" onClick={() => handleViewClick(SthanUser.person_id)}>
                          OTP
                        </button>

                        <button type="button" className="btn btn-warning btn-ico newicobtn" onClick={() => handleEditClick(SthanUser.person_id, SthanUser.name, SthanUser.mobile, SthanUser.responsibility)}>
                          <i className="bx bxs-edit icon"></i>
                        </button>



                        {auth?.roles === "Arthiksakha" ? (
                          <button
                            type="button"
                            className="tableButton btn btn-info newicobtn newviewbtn"
                            onClick={() =>
                              handleArthiksakhaAddSthantoUser(
                                SthanUser.person_id,
                                SthanUser.name,
                                SthanUser.mobile
                              )
                            }
                          >
                            Add sthan
                          </button>
                        ) : auth?.roles === "Admin" ? (
                          <button
                            type="button"
                            className="tableButton btn btn-info newicobtn newviewbtn"
                            onClick={() =>
                              handleAdminAddSthantoUser(
                                SthanUser.person_id,
                                SthanUser.name,
                                SthanUser.mobile
                              )
                            }
                          >
                            Add sthan
                          </button>
                        ) : null}

                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>


          </table>

          {totalPages > 1 && (
            <div className="pagination">
              <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index}
                  onClick={() => handlePageChange(index + 1)}
                  disabled={currentPage === index + 1}
                >
                  {index + 1}
                </button>
              ))}
              <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
            </div>
          )}
        </div>
      </section>
      <TopBar />
      {/* </Container> */}
    </>
  );
};

export default ListSthanUsers;
